// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2FdWF","content":"GlobalSearch_content__aew6t"};